// extracted by mini-css-extract-plugin
module.exports = {"vertical_line":"TeamPerformance-module--vertical_line--2H2hZ","vertical_first_line":"TeamPerformance-module--vertical_first_line--UAViS"};